import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_DOMAIN } from '../../utils/constants';
import { get_dashboard } from './dashboardConstant';

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_DOMAIN,
  prepareHeaders: (headers) => {
      const token = localStorage.getItem('authToken');

      if (!token) {
          return headers; // Return headers without Authorization
      }

      headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', 'application/json');
      return headers;
  }
});

// A wrapper function to handle token verification and 401 errors
const baseQueryWithAuth = async (args, api, extraOptions) => {

  const token = localStorage.getItem('authToken');

  if (!token) {
      window.location.href = "/login"; // Redirect if no token is present
      return { error: { status: 401, message: "Unauthorized - No Token" } };
  }

  const result = await baseQuery(args, api, extraOptions);


  if (result?.error?.status === 401) {
      
      // Remove token from localStorage
      localStorage.removeItem('authToken');

      // Redirect to login page
      window.location.href = "/login"; // Adjust based on routing

      // Optionally, dispatch a logout action to update Redux state
      // api.dispatch(logoutAction());
  }
  return result;
};


export const dashboardSlice = createApi({
    reducerPath: 'dashboardApi', // Unique name for the slice
    baseQuery: baseQueryWithAuth,
    endpoints: (builder) => ({
      getdash: builder.query({
        query: (credentials) => ({
          url: get_dashboard, // Replace with your login endpoint
          method: 'POST',
          body: credentials,
        }),
      }),
    })

});

export const { useGetdashQuery } = dashboardSlice